<template>
  <summary class="timetable-header">
    <span class="timetable-header__title">
      <template v-if="!isSingleDayChampionship">
        <span>{{ title }}</span>
        <span
          class="timetable-header__title-icon"
          :class="{ 'timetable-header__title-icon--has-title': title }"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.7266 9.33337L8.23667 4.84348C7.55325 4.16007 6.44522 4.16007 5.7618 4.84348L1.27191 9.33338L3.39323 9.33337L6.82246 5.90414C6.92009 5.80651 7.07838 5.80651 7.17601 5.90414L10.6052 9.33337L12.7266 9.33337Z"
              fill="black"
            />
          </svg>
        </span>
      </template>
    </span>
    <span class="timetable__block-date">{{ getTimeTableDate(date) }}</span>
  </summary>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import dayjs from 'dayjs'
import useDisplayDependingOnLang from '@/components/hook/useDisplayDependingOnLang'

export default defineComponent({
  name: 'TimetableHeaderParts',
  props: {
    title: {
      type: String,
      require: true,
    },
    date: {
      type: String,
      require: true,
    },
    /**
     * 1日のみの大会かどうか
     */
    isSingleDayChampionship: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { getDisplayDate } = useDisplayDependingOnLang()
    /**
     * タイムテーブル見出しに表示する日付
     */
    const getTimeTableDate = (date: string) => {
      if (!date) {
        return ''
      }
      return getDisplayDate(dayjs(date).valueOf(), 'YYYY.MM.DD(ddd)', 'MMM. DD, YYYY(ddd)')
    }
    return {
      getTimeTableDate,
    }
  },
})
</script>

<style scoped lang="scss">
.timetable-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  list-style: none;

  &::marker,
  &::-webkit-details-marker {
    display: none;
  }

  &__title {
    display: flex;
    align-items: center;
    font-family: $fontHeading;
    font-size: 16px;
    font-weight: bold;
    color: $black;
    letter-spacing: 0.04em;
    line-height: 1.1;

    &-icon {
      display: flex;
      width: 14px;
      height: 14px;
      transform: rotate(180deg);

      &--has-title {
        margin-left: 8px;
      }
    }
  }

  &__date {
    font-size: 12px;
    font-weight: 500;
    color: $black;
    letter-spacing: 0.04em;
  }
}
</style>
